import React from "react";
import { motion } from "framer-motion";
import AppWrap from "../../wrapper/AppWrap";
import { images } from "../../constants";

const abouts = [
  {
    title: "Product Design x Engineering",
    description:
      "I bridge product strategy with front-end craft - translating ideas into clear user journeys, interactive prototypes, and production-ready code.",
    imgUrl: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1200&q=80",
    tags: ["Design systems", "Prototyping", "Accessibility"],
  },
  {
    title: "Full-stack Web & Mobile",
    description:
      "React, Next.js, Node, and mobile experiences with Expo/React Native. I keep apps fast, secure, and delightful on every device.",
    imgUrl: images.about03,
    tags: ["Next.js", "TypeScript", "React Native", "Nest.js"],
  },
  {
    title: "Startup Partner",
    description:
      "From zero-to-one to growth, I help founders validate, launch, and iterate - shipping the right thing quickly with measurable outcomes.",
    imgUrl: images.startup,
    tags: ["MVPs", "Analytics", "Iteration rituals"],
  },
];

const About = () => {
  return (
    <div className="space-y-8">
      <div className="flex flex-col gap-3">
        <p className="text-sm uppercase tracking-[0.3em] text-primary">What I do</p>
        <div className="flex flex-col gap-2">
          <h2 className="text-3xl sm:text-4xl font-bold text-white">Intentional craft, measurable results.</h2>
          <p className="text-slate-300 max-w-3xl">
            I merge product thinking with full-stack execution. Here are the lanes where I bring the most leverage for
            founders and product teams.
          </p>
        </div>
      </div>

      <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
        {abouts.map((about, index) => (
          <motion.article
            key={about.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="group rounded-3xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl relative"
          >
            <div className="relative h-56 overflow-hidden">
              <img src={about.imgUrl} alt={about.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
              <div className="absolute bottom-3 left-3 px-4 py-2 rounded-full bg-white/10 border border-white/15 text-xs text-slate-100">
                {about.tags[0]}
              </div>
            </div>
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-semibold text-white">{about.title}</h3>
              <p className="text-slate-300 text-sm leading-relaxed">{about.description}</p>
              <div className="flex flex-wrap gap-2 pt-2">
                {about.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs bg-white/5 border border-white/10 text-slate-200"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  );
};

export default AppWrap(About, "about");
